import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _answerOption = { content: 'Map#_contentComponent' };
var _choiceQuestion = {
    content: 'Map#_contentComponent',
    options: '_answerOption',
};
var _contentComponent = {
    number: 'DOUBLE',
    date: 'google.protobuf.Timestamp',
    choiceQuestion: '_choiceQuestion',
    freeTextQuestion: '_freeTextQuestion',
    group: '_group',
    list: '_list',
};
var _freeTextQuestion = { content: 'Map#_contentComponent' };
var _getPageContentRequest = {};
var _getPageContentResponse = { page: '_page' };
var _group = { content: 'Map#_contentComponent' };
var _list = { values: '_listValue' };
var _listPageContentsRequest = {};
var _listPageContentsResponse = { pages: '_page' };
var _listValue = { content: 'Map#_contentComponent' };
var _page = { content: 'Map#_contentComponent' };
var _queryPageContentsRequest = {};
var _queryPageContentsResponse = { pages: '_page' };
function resolveWixApiFunnelBuilderV2PageContentServiceUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/funnel-builder-service',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/funnel-builder-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/funnel-builder-service',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/funnel-builder-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/funnel-builder-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Returns a page entity which contains content and other metadata */
export function getPageContent(payload) {
    var _a = serializer(_getPageContentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPageContentResponse, {
        _answerOption: _answerOption,
        _choiceQuestion: _choiceQuestion,
        _contentComponent: _contentComponent,
        _freeTextQuestion: _freeTextQuestion,
        _group: _group,
        _list: _list,
        _listValue: _listValue,
        _page: _page,
    }).fromJSON;
    function __getPageContent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel_builder.v2.page',
            method: 'POST',
            methodFqn: 'wix.api.funnel.builder.v2.PageContentService.GetPageContent',
            url: resolveWixApiFunnelBuilderV2PageContentServiceUrl({
                protoPath: '/v2/page-content/{pageId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPageContent.fromReq = fromReq;
    __getPageContent.__isAmbassador = true;
    return __getPageContent;
}
/** Returns page entities in batch with content and other metadata */
export function listPageContents(payload) {
    var _a = serializer(_listPageContentsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listPageContentsResponse, {
        _answerOption: _answerOption,
        _choiceQuestion: _choiceQuestion,
        _contentComponent: _contentComponent,
        _freeTextQuestion: _freeTextQuestion,
        _group: _group,
        _list: _list,
        _listValue: _listValue,
        _page: _page,
    }).fromJSON;
    function __listPageContents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel_builder.v2.page',
            method: 'POST',
            methodFqn: 'wix.api.funnel.builder.v2.PageContentService.ListPageContents',
            url: resolveWixApiFunnelBuilderV2PageContentServiceUrl({
                protoPath: '/v2/page-contents',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listPageContents.fromReq = fromReq;
    __listPageContents.__isAmbassador = true;
    return __listPageContents;
}
/** Query page entities */
export function queryPageContents(payload) {
    var _a = serializer(_queryPageContentsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryPageContentsResponse, {
        _answerOption: _answerOption,
        _choiceQuestion: _choiceQuestion,
        _contentComponent: _contentComponent,
        _freeTextQuestion: _freeTextQuestion,
        _group: _group,
        _list: _list,
        _listValue: _listValue,
        _page: _page,
    }).fromJSON;
    function __queryPageContents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel_builder.v2.page',
            method: 'POST',
            methodFqn: 'wix.api.funnel.builder.v2.PageContentService.QueryPageContents',
            url: resolveWixApiFunnelBuilderV2PageContentServiceUrl({
                protoPath: '/v2/page-contents/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryPageContents.fromReq = fromReq;
    __queryPageContents.__isAmbassador = true;
    return __queryPageContents;
}
//# sourceMappingURL=http.impl.js.map